var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrossBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    d: "M4.84 4.84c.413-.412 1.065-.453 1.525-.103l.119.103L12 10.358l5.516-5.518c.424-.423 1.093-.451 1.55-.084l.094.084c.412.413.453 1.065.092 1.539l-.092.105L13.642 12l5.518 5.516c.423.424.451 1.093.084 1.55l-.084.094c-.413.412-1.065.454-1.539.092l-.105-.092L12 13.642 6.484 19.16c-.424.423-1.093.451-1.55.084l-.094-.084c-.412-.413-.454-1.065-.092-1.539l.092-.105L10.357 12 4.84 6.484c-.423-.424-.451-1.093-.084-1.55l.084-.094z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#333",
    fillRule: "evenodd",
    d: "M4.628 4.628c.519-.518 1.34-.57 1.918-.13l.017.012.133.118L12 9.933l5.304-5.305c.533-.533 1.375-.568 1.95-.106l.012.01.106.096c.52.52.57 1.342.119 1.933l-.007.008-.112.127L14.067 12l5.305 5.305c.533.532.568 1.374.106 1.949l-.01.012-.096.106c-.52.521-1.342.57-1.933.119l-.008-.006-.127-.113-5.305-5.305-5.303 5.305c-.533.533-1.375.568-1.95.106l-.012-.01-.106-.096c-.52-.52-.57-1.342-.119-1.932l.007-.009.112-.127L9.932 12 4.628 6.696c-.533-.533-.568-1.375-.106-1.95l.01-.012.096-.106zM10.357 12L4.84 17.517l-.092.105c-.362.473-.32 1.126.092 1.538l.095.085c.456.367 1.125.338 1.549-.085l5.515-5.517 5.517 5.517.105.092c.474.362 1.126.32 1.539-.092l.084-.094c.367-.457.34-1.126-.084-1.55L13.642 12l5.518-5.516.092-.105c.361-.474.32-1.126-.092-1.538l-.095-.085c-.456-.367-1.125-.339-1.549.085L12 10.358 6.484 4.84l-.12-.104c-.46-.35-1.111-.309-1.524.104l-.084.094c-.367.456-.34 1.125.084 1.549L10.357 12z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossBlack);
export default __webpack_public_path__ + "static/media/cross-black.fe05648721235e1278e47bf2d7dd745b.svg";
export { ForwardRef as ReactComponent };